import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../loader.scss";

export default function Loader() {
    const containerRef = useRef(null);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        gsap.registerPlugin(ScrollTrigger);

        let ctx;
        const timeoutId = setTimeout(() => {
            ctx = gsap.context(() => {
                const isMobile = typeof window !== 'undefined' && window.matchMedia("(max-width: 768px)").matches;

                if (isMobile) {
                    gsap.set(".img-flower-single", { scale: 3, delay: 0.5, x: 0, y: 0, rotation: 0, transformOrigin: "50% 50%", ease: 'power1.out' });
                } else {
                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: document.documentElement,
                            start: "top top",
                            end: "bottom bottom",
                            scrub: 1,
                        }
                    });

                    // Move each image towards a unique corner and rotate on scroll
                    /*   tl.to(".img-flower", { x: "0vw", scale: 4, rotation: 850, transformOrigin: "50% 50%", ease: 'power1.out' }, 0); */

                    tl.to(".img-flower-single", { x: "35vw", scale: 3, rotation: 710, transformOrigin: "50% 50%", ease: 'power1.out' }, 0);
                }



                /*    tl.to(".img-labo", { x: "-35vw", y: "-10vh", scale: 2, rotation: 710, transformOrigin: "50% 50%", ease: "none" }, 0)
                .to(".img-lol", { x: "20vw", y: "0vh", scale: 2, rotation: -710, transformOrigin: "50% 50%", ease: "none" }, 0)
                .to(".img-flower", { x: "40vw", y: "-10vh", scale: 2, rotation: 710, transformOrigin: "50% 50%", ease: "none" }, 0) */

                // After 3.5s, fade out the three initial images
                // gsap.to([".img-flower,  .img-labo, .img-lol"], { autoAlpha: 0, duration: 0.3, delay: 0.5 });

                // Show .img-labo and .img-lol again near the bottom (last 5% of page)
                const bottomReveal = gsap.to([".img-labo", ".img-lol"], {
                    autoAlpha: 1,
                    duration: 0.4,
                    ease: 'power1.out',
                    paused: true,

                });

                let wasNearBottom = false;
                ScrollTrigger.create({
                    trigger: document.documentElement,
                    start: "top top",
                    end: "bottom bottom",
                    onUpdate: (self) => {
                        const nearBottom = self.progress >= 0.9;
                        if (nearBottom !== wasNearBottom) {
                            wasNearBottom = nearBottom;
                            if (nearBottom) bottomReveal.play(); else bottomReveal.reverse();
                        }
                    }
                });




                // Ensure ScrollTrigger is refreshed after images/layout are ready
                setTimeout(() => {
                    ScrollTrigger.refresh();
                }, 100);
            }, containerRef);
        }, 3000);

        // Extra: refresh on window load for robustness
        window.addEventListener('load', ScrollTrigger.refresh);

        return () => {
            clearTimeout(timeoutId);
            if (ctx) ctx.revert();
        };
    }, []);

    return (
        <div className="loader-container" ref={containerRef}>
            {/*      <img className="img-labo" src="/content/logo/labo01.png" alt="Labo" />
            <img className="img-lol" src="/content/logo/lol01.png" alt="Lol" />
            <img className="img-flower" src="/content/logo/flower01.png" alt="Flower" /> */}
            <img className="img-labo" src="/content/logo/labo.png" alt="Labo" />
            <img className="img-lol" src="/content/logo/lol.png" alt="Lol" />
            <img className="img-flower-single" src="/content/logo/single-flower.png" alt="Flower Single" />
        </div>
    );
}
